import { useState } from "react";

const useGeolocation = (options = {}, desiredAccuracy = 50) => {
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
    accuracy: null,
    altitude: null,
    altitudeAccuracy: null,
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [watchId, setWatchId] = useState(null); // Save watch ID to stop geolocation when necessary

  const getLocation = (enableHighAccuracy = true) => {
    if (!navigator.geolocation) {
      setError("Geolocation is not supported by your browser.");
      return;
    }

    setLoading(true);

    const id = navigator.geolocation.watchPosition(
      (position) => {
        const { latitude, longitude, accuracy, altitude, altitudeAccuracy } =
          position.coords;

        // Update location and accuracy in real-time
        setLocation({
          latitude,
          longitude,
          accuracy,
          altitude: altitude || "N/A",
          altitudeAccuracy: altitudeAccuracy || "N/A",
        });

        // Check if the accuracy meets the desired threshold
        if (accuracy <= desiredAccuracy) {
          // Stop watching the position once accuracy is good enough
          navigator.geolocation.clearWatch(id);
          setWatchId(null);
          setLoading(false);
        }
      },
      (err) => {
        setError(
          "Unable to retrieve location. Make sure location access is allowed."
        );
        setLoading(false);
      },
      {
        enableHighAccuracy,
        timeout: 10000,
        maximumAge: 0,
        ...options,
      }
    );

    setWatchId(id); // Save watch ID to stop watching later if needed
  };

  // Optionally provide a function to stop geolocation
  const stopWatching = () => {
    if (watchId !== null) {
      navigator.geolocation.clearWatch(watchId);
      setWatchId(null);
      setLoading(false);
    }
  };

  return { location, error, loading, getLocation, stopWatching };
};

export default useGeolocation;
